import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '明星八卦', path: '/category/mingxing-bagua' },
    { label: '网红黑料', path: '/category/wanghong-heiliao' },
    { label: '暴走视频', path: '/category/baozou-shipin' },
    { label: '内幕大瓜', path: '/category/neimu-dagua' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '更新日志', path: '/about' },
    { label: '免责声明', path: '/about' },
  ],
  social: [
    { label: '微博吃瓜', path: '#', external: true },
    { label: '抖音爆料', path: '#', external: true },
    { label: '小红书', path: '#', external: true },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-50 border-t border-background-200/60">
      {/* Upper section */}
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand column */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-fill text-primary-500 text-2xl"></i>
              </div>
              <span className="text-lg font-bold tracking-tight text-foreground-50 whitespace-nowrap">
                黑料<span className="text-primary-500">视频</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              打造全网最狠吃瓜基地，每日整理明星八卦、网红黑料、暴走视频合集。拒绝官腔，只爆猛料，凌晨更新不迷路。
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              快速导航
            </h4>
            <ul className="space-y-3">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              关于本站
            </h4>
            <ul className="space-y-3">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              关注我们
            </h4>
            <ul className="space-y-3">
              {footerLinks.social.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.path}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Brand big text section */}
      <div className="border-t border-background-200/60 py-10 overflow-hidden">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="text-[clamp(3rem,10vw,10rem)] font-black text-foreground-200/10 tracking-[-0.05em] leading-none select-none text-center whitespace-nowrap">
            黑 料 不 打 烊
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-200/60 py-5">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 黑料视频 · 全网最狠吃瓜基地 · 内容仅供娱乐
          </p>
          <p className="text-xs text-foreground-700">
            凌晨更新 · 传送门不迷路
          </p>
        </div>
      </div>
    </footer>
  );
}